var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-go2Top"},[_c('transition',{attrs:{"name":"fadeIn"}},[_c('v-touch',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGoTop),expression:"showGoTop"}],staticClass:"goTopButton",on:{"tap":_vm.go2Top}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/gotoTop.vue?vue&type=template&id=2f41edf1&scoped=true&
// module id = null
// module chunks = 